import React from 'react';
import { Component } from 'react';
import { connect } from 'react-redux';
import Table from '../../components/Table';
import { createSidebar } from '../../redux/actions/general/sidebar';
import { listTimesheetReport } from '../../redux/actions/table/timesheet_report';
import { listActiveModules } from '../../redux/actions/general/active_modules';
import Tooltip from '../../components/Tooltip';
import { __, dateFrom, hasURLParam, setURLParam } from '../../core/utils';
import TableNA from '../../components/TableNA';

const mapStateToProps = (state) => {
  return {
    table: state.table['timesheet_report'],
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      setTableParams: (params) =>
        dispatch({
          type: 'table.timesheet_report/SET_TABLE_PARAMS',
          params,
        }),
    },
  };
};

@connect(mapStateToProps, mapDispatchToProps)
class TimesheetReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      team_roles: [],
    };
  }

  componentDidMount() {
    createSidebar({
      title: __('submenu.title.time'),
      items: [
        {
          title: __('submenu.title.all-times'),
          link: () => '/timesheets',
        },
        {
          title: __('submenu.title.all-timesheet-reports'),
          link: () => '/timesheet_report',
          active: true,
        },
      ],
    });

    setURLParam('filter.user', 'any');
    setURLParam('filter.project', 'any');
    setURLParam('filter.stage', 'any');
    setURLParam('filter.task', 'any');
    setURLParam('filter.year', 'any');
  }

  _handleOpacity(value, row) {
    return !row.deactivated ? (
      value
    ) : (
      <div className={styles.hidden}>{value}</div>
    );
  }

  render() {
    const columns = [
      {
        key: 'user_name',
        name: __('table.columns.timesheet-report-user'),
        required: true,
        value: (value) => <Tooltip text={value}>{value}</Tooltip>,
      },
      {
        key: 'project_name',
        name: __('table.columns.timesheet-report-project'),
        width: 100,
        default: true,
        value: (value) =>
          value ? (
            <Tooltip text={_.last(_.split(value, ': '))}>
              {_.first(_.split(value, ': '))}
            </Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'stage_name',
        name: __('table.columns.timesheet-report-stage'),
        width: 100,
        default: true,
        value: (value) =>
          value ? (
            <Tooltip text={_.last(_.split(value, ': '))}>
              {_.first(_.split(value, ': '))}
            </Tooltip>
          ) : (
            <TableNA />
          ),
      },
      {
        key: 'date',
        name: __('table.columns.timesheet-report-date'),
        required: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
        // value: (value) => (
        //   <Tooltip text={dateFrom(value)}>{dateFrom(value)}</Tooltip>
        // ),
      },
      {
        key: 'task_title',
        name: __('table.columns.timesheet-report-task'),
        active: false,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'address_book_company_name',
        name: __('table.columns.timesheet-report-address-book-company-name'),
        width: 200,
        active: false,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
        default: true,
      },
      {
        key: 'hours',
        name: __('table.columns.timesheet-report-duration'),
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'working_hours',
        name: __('table.columns.timesheet-report-working-hours'),
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'absent_hours',
        name: __('table.columns.timesheet-report-absent-hours'),
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
      {
        key: 'overtime',
        name: __('table.columns.timesheet-report-overtime'),
        default: true,
        value: (value) =>
          value ? <Tooltip text={value}>{value}</Tooltip> : <TableNA />,
      },
    ];

    return (
      <Table
        listAction={listTimesheetReport}
        name='timesheet_report'
        title={__('submenu.title.timesheet-report')}
        columns={columns}
        onLoad={() => listActiveModules()}
      />
    );
  }
}

export default TimesheetReport;
